import { BrowserModule } from '@angular/platform-browser';
import { HttpModule} from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { OneSignal } from '@ionic-native/onesignal';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule, AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyDVyS_ZeUKJjAtv_LS6Ug8R2eehLCGjqM0",
  authDomain: "cloudtabletop.firebaseapp.com",
  databaseURL: "https://cloudtabletop.firebaseio.com",
  projectId: "cloudtabletop",
  storageBucket: "cloudtabletop.appspot.com",
  messagingSenderId: "879530731812"
};

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { GlobalServiceProvider } from '../providers/global-service/global-service';
import { HttpServiceProvider } from '../providers/http-service/http-service';
import { MessageServiceProvider } from '../providers/message-service/message-service';
@NgModule({
  declarations: [
    MyApp,
    LoginPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, { preloadModules: true,mode:'md'}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    OneSignal,
    AngularFireDatabase,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    GlobalServiceProvider,
    HttpServiceProvider,
    MessageServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts